// extracted by mini-css-extract-plugin
export default {"search-hint-container":"search-hint-container","arrow":"arrow","curve":"curve","point":"point","hint-container":"hint-container","hint":"hint","category-hint":"category-hint"};